export default {
    items: [
        {
            id: 'navigation',
            title: 'Navigation',
            type: 'group',
            icon: 'icon-navigation',
            children: [
                {
                    id: 'dashboard',
                    title: 'Dashboard',
                    type: 'item',
                    url: '/dashboard',
                    icon: 'feather icon-home',
                },
                {
                    id: 'deals',
                    title: 'Deals of the Day',
                    type: 'item',
                    url: '/deals',
                    icon: 'feather icon-home',
                },
                {
                    id: 'featured-products',
                    title: 'Featured Products',
                    type: 'item',
                    url: '/featuredProducts',
                    icon: 'feather icon-home',
                }
            ]
        },
        {
            id: 'orders-section',
            title: 'Orders',
            type: 'group',
            icon: 'icon-navigation',
            children: [
                {
                    id: 'Orders',
                    title: 'Orders',
                    type: 'item',
                    url: '/orders',
                    icon: 'feather icon-sidebar',
                },
                {
                    id: 'Pin Codes',
                    title: 'Pin Codes',
                    type: 'item',
                    url: '/pincodes',
                    icon: 'feather icon-sidebar',
                },
            ]
        },
        // {
        //     id: 'app-home-page-section',
        //     title: 'App Home Page',
        //     type: 'group',
        //     icon: 'icon-navigation',
        //     children: [
        //         {
        //             id: 'HomePageComponents',
        //             title: 'Home Page Components',
        //             type: 'item',
        //             url: '/homeComponents',
        //             icon: 'feather icon-sidebar',
        //         },
        //     ]
        // },
        {
            id: 'products-section',
            title: 'Products',
            type: 'group',
            icon: 'icon-navigation',
            children: [
                {
                    id: 'products',
                    title: 'Products',
                    type: 'item',
                    url: '/products',
                    icon: 'feather icon-sidebar',
                },
                {
                    id: 'product-variants',
                    title: 'Product Variants',
                    type: 'item',
                    url: '/productVariants',
                    icon: 'feather icon-sidebar',
                },
                {
                    id: 'product-categories',
                    title: 'Product Categories',
                    type: 'item',
                    url: '/productCategories',
                    icon: 'feather icon-sidebar',
                },
                {
                    id: 'product-subcategories',
                    title: 'Product Subcategories',
                    type: 'item',
                    url: '/productSubcategories',
                    icon: 'feather icon-sidebar',
                },
                {
                    id: 'product-brands',
                    title: 'Product Brands',
                    type: 'item',
                    url: '/productBrands',
                    icon: 'feather icon-sidebar',
                }
            ]
        },
        // {
        //     id: 'users',
        //     title: 'Users',
        //     type: 'group',
        //     icon: 'icon-pages',
        //     children: [
        //         {
        //             id: 'user-list',
        //             title: 'Users',
        //             type: 'item',
        //             url: '/users',
        //             classes: 'nav-item',
        //             icon: 'feather icon-sidebar'
        //         },
        //     ]
        // },
    ]
}